import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'gatsby'

// import pic01 from '../images/pic01.jpg'
// import pic02 from '../images/pic02.jpg'
// import pic03 from '../images/pic03.jpg'

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
//      uhntemp: 250.0,
//      uhnsatratio: 8.0,
//      uhnresult: 0.0,
//      bhnh2so4: 1E9,
      // bhntemp: 280,
      // bhnrh: 50.0,
      // bhnsfcarea: 20.0,

      // thnh2so4: 1E9,
      // thntemp: 190.0,
      // thnrh: 50.0,
      // thnsfcarea: 20.0,
      // thnnh3: 1E5,

      // bimnh2so4: 1E7,
      // bimntemp: 280.0,
      // bimnrh: 50.0,
      // bimnirate: 5.0,
      // bimnsfcarea: 50.0,

      // timnh2so4: 1E7,
      // timntemp: 280.0,
      // timnrh: 50.0,
      // timnirate: 5.0,
      // timnsfcarea: 50.0,
      // timnnh3: 1E5,
    }

//    this.handleUHNcalc = this.handleUHNcalc.bind(this);
//    this.handleUHNtemp = this.handleUHNtemp.bind(this);
//    this.handleUHNsrat = this.handleUHNsrat.bind(this);

    this.handleBHNcalc = this.handleBHNcalc.bind(this);
    this.handleBHNh2so4 = this.handleBHNh2so4.bind(this);
    this.handleBHNtemp = this.handleBHNtemp.bind(this);
    this.handleBHNrh = this.handleBHNrh.bind(this);
    this.handleBHNsfcarea = this.handleBHNsfcarea.bind(this);

    this.handleTHNcalc = this.handleTHNcalc.bind(this);
    this.handleTHNh2so4 = this.handleTHNh2so4.bind(this);
    this.handleTHNtemp = this.handleTHNtemp.bind(this);
    this.handleTHNrh = this.handleTHNrh.bind(this);
    this.handleTHNsfcarea = this.handleTHNsfcarea.bind(this);
    this.handleTHNnh3 = this.handleTHNnh3.bind(this);

    this.handleBIMNcalc = this.handleBIMNcalc.bind(this);
    this.handleBIMNh2so4 = this.handleBIMNh2so4.bind(this);
    this.handleBIMNtemp = this.handleBIMNtemp.bind(this);
    this.handleBIMNrh = this.handleBIMNrh.bind(this);
    this.handleBIMNirate = this.handleBIMNirate.bind(this);
    this.handleBIMNsfcarea = this.handleBIMNsfcarea.bind(this);

    this.handleTIMNcalc = this.handleTIMNcalc.bind(this);
    this.handleTIMNh2so4 = this.handleTIMNh2so4.bind(this);
    this.handleTIMNtemp = this.handleTIMNtemp.bind(this);
    this.handleTIMNrh = this.handleTIMNrh.bind(this);
    this.handleTIMNirate = this.handleTIMNirate.bind(this);
    this.handleTIMNsfcarea = this.handleTIMNsfcarea.bind(this);
    this.handleTIMNnh3 = this.handleTIMNnh3.bind(this);
  }

  // handleUHNcalc(event) {
  //   event.preventDefault();

  //   var v1 = this.state.uhntemp * this.state.uhnsatratio;
  //   var v2 = parseFloat(this.state.uhntemp);
  //   var v3 = 1E10 * 4.54;
  //   document.getElementById("uhnout1").value = v1.toExponential();
  //   document.getElementById("uhnout2").value = v2.toExponential();
  //   document.getElementById("uhnout3").value = v3.toExponential();
  // }

  // handleUHNtemp(event) {
  //   this.setState({uhntemp: event.target.value});
  // }

  // handleUHNsrat(event) {
  //   this.setState({uhnsatratio: event.target.value});
  // }

  // BHN
  handleBHNcalc(event) {
    event.preventDefault();
    
    const bhnPayload = {
      "h2so4":`${this.state.bhnh2so4}`,
      "temp":`${this.state.bhntemp}`,
      "rh":`${this.state.bhnrh}`,
      "sfcArea":`${this.state.bhnsfcarea}`
    };

    const xhr = new XMLHttpRequest();
    const url = 'http://apm.asrc.albany.edu:3000/nrcapi/bhn';
    //const url = 'http://localhost:3000/nrcapi/bhn';
    xhr.responseType = 'json';

    xhr.onreadystatechange = () => {
      document.getElementById("bhnstatus").innerHTML = "&nbsp;&nbsp;Calculating...";

      if(xhr.readyState === XMLHttpRequest.DONE){
        document.getElementById("bhnstatus").innerHTML = "&nbsp;&nbsp;Ready...";

        if (xhr.response.eCode !== '0') {
          alert(`BHN Calculator Error: ${xhr.response.eCode} : ${xhr.response.eMsg}`);
             document.getElementById("bhnNucRate").value = 0.0;
        } else {
             document.getElementById("bhnNucRate").value = xhr.response.nucRate;
        }
      }
    }

    // if(`${this.state.bhnh2so4}` === null || `${this.state.bhntemp}` === null ||
    //   `${this.state.bhnrh}` === null || `${this.state.bhnsfcarea}` === null) {
    //     alert("Missing input, one or more fields empty!");
    // }
    xhr.open('POST', url);
    xhr.setRequestHeader("Content-Type","application/json");
    xhr.send(JSON.stringify(bhnPayload));

  }

  handleBHNh2so4(event) {
    this.setState({bhnh2so4: event.target.value});
  }
  handleBHNtemp(event) {
    this.setState({bhntemp: event.target.value});
  }
  handleBHNrh(event) {
    this.setState({bhnrh: event.target.value});
  }
  handleBHNsfcarea(event) {
    this.setState({bhnsfcarea: event.target.value});
  }

  // THN
  handleTHNcalc(event) {
    event.preventDefault();

    const thnPayload = {
      "h2so4":`${this.state.thnh2so4}`,
      "temp":`${this.state.thntemp}`,
      "rh":`${this.state.thnrh}`,
      "sfcArea":`${this.state.thnsfcarea}`,
      "nh3": `${this.state.thnnh3}`,
    };

    const xhr = new XMLHttpRequest();
    const url = 'http://apm.asrc.albany.edu:3000/nrcapi/thn';
    //const url = 'http://localhost:3000/nrcapi/thn';
    xhr.responseType = 'json';

    xhr.onreadystatechange = () => {
      document.getElementById("thnstatus").innerHTML = "&nbsp;&nbsp;Calculating...";

      if(xhr.readyState === XMLHttpRequest.DONE){
        document.getElementById("thnstatus").innerHTML = "&nbsp;&nbsp;Ready...";

        if (xhr.response.eCode !== '0') {
          alert(`THN Calculator Error: ${xhr.response.eCode} : ${xhr.response.eMsg}`);
             document.getElementById("thnNucRate").value = 0.0;
       } else {
             document.getElementById("thnNucRate").value = xhr.response.nucRate;
       }
      }
    }
    xhr.open('POST', url);
    xhr.setRequestHeader("Content-Type","application/json");
    xhr.send(JSON.stringify(thnPayload));

  }

  handleTHNh2so4(event) {
    this.setState({thnh2so4: event.target.value});
  }
  handleTHNtemp(event) {
    this.setState({thntemp: event.target.value});
  }
  handleTHNrh(event) {
    this.setState({thnrh: event.target.value});
  }
  handleTHNsfcarea(event) {
    this.setState({thnsfcarea: event.target.value});
  }
  handleTHNnh3(event) {
    this.setState({thnnh3: event.target.value});
  }

  // BIMN
  handleBIMNcalc(event) {
    event.preventDefault();

    const bimnPayload = {
      "h2so4":`${this.state.bimnh2so4}`,
      "temp":`${this.state.bimntemp}`,
      "rh":`${this.state.bimnrh}`,
      "ionRate":`${this.state.bimnirate}`,
      "sfcArea":`${this.state.bimnsfcarea}`,
    };

    const xhr = new XMLHttpRequest();
    const url = 'http://apm.asrc.albany.edu:3000/nrcapi/bimn';
    //const url = 'http://localhost:3000/nrcapi/bimn';
    xhr.responseType = 'json';

    xhr.onreadystatechange = () => {
      document.getElementById("bimnstatus").innerHTML = "&nbsp;&nbsp;Calculating...";

      if(xhr.readyState === XMLHttpRequest.DONE){
        document.getElementById("bimnstatus").innerHTML = "&nbsp;&nbsp;Ready...";

        if (xhr.response.eCode !== '0') {
          alert(`BIMN Calculator Error: ${xhr.response.eCode} : ${xhr.response.eMsg}`);
          document.getElementById("bimnNucRate").value = 0.0;
       } else {
          document.getElementById("bimnNucRate").value = xhr.response.nucRate;
       }
      }
    }
    xhr.open('POST', url);
    xhr.setRequestHeader("Content-Type","application/json");
    xhr.send(JSON.stringify(bimnPayload));
  }

  handleBIMNh2so4(event) {
    this.setState({bimnh2so4: event.target.value});
  }
  handleBIMNtemp(event) {
    this.setState({bimntemp: event.target.value});
  }
  handleBIMNrh(event) {
    this.setState({bimnrh: event.target.value});
  }
  handleBIMNirate(event) {
    this.setState({bimnirate: event.target.value});
  }
  handleBIMNsfcarea(event) {
    this.setState({bimnsfcarea: event.target.value});
  }

  // TIMN
  handleTIMNcalc(event) {
    event.preventDefault();
  
    const timnPayload = {
      "h2so4":`${this.state.timnh2so4}`,
      "temp":`${this.state.timntemp}`,
      "rh":`${this.state.timnrh}`,
      "ionRate":`${this.state.timnirate}`,
      "sfcArea":`${this.state.timnsfcarea}`,
      "nh3":`${this.state.timnnh3}`
    };

    const xhr = new XMLHttpRequest();
    const url = 'http://apm.asrc.albany.edu:3000/nrcapi/timn';
    //const url = 'http://localhost:3000/nrcapi/timn';
    xhr.responseType = 'json';

    xhr.onreadystatechange = () => {
      document.getElementById("timnstatus").innerHTML = "&nbsp;&nbsp;Calculating...";

      if(xhr.readyState === XMLHttpRequest.DONE){
        document.getElementById("timnstatus").innerHTML = "&nbsp;&nbsp;Ready...";

        if (xhr.response.eCode !== '0') {
          alert(`TIMN Calculator Error: ${xhr.response.eCode} : ${xhr.response.eMsg}`);
          document.getElementById("timnNucRate").value = 0.0;
       } else {
          document.getElementById("timnNucRate").value = xhr.response.nucRate;
       }
      }
    }
    xhr.open('POST', url);
    xhr.setRequestHeader("Content-Type","application/json");
    xhr.send(JSON.stringify(timnPayload));

  }

  handleTIMNh2so4(event) {
    this.setState({timnh2so4: event.target.value});
  }
  handleTIMNtemp(event) {
    this.setState({timntemp: event.target.value});
  }
  handleTIMNrh(event) {
    this.setState({timnrh: event.target.value});
  }
  handleTIMNirate(event) {
    this.setState({timnirate: event.target.value});
  }
  handleTIMNsfcarea(event) {
    this.setState({timnsfcarea: event.target.value});
  }
  handleTIMNnh3(event) {
    this.setState({timnnh3: event.target.value});
  }

  // REACT RENDER
  render() {
    const inpStyle = {
      backgroundColor: '#999966',
      color: '#000'
    };
   
    const outStyle = {
      backgroundColor: '#c0c0c0',
      color: '#000'
    }

    const divStyle = {
      width: 200,
      display: 'inline-block',
      verticalAlign: 'middle',
      paddingRight: '2px',
      paddingBottom: '5px'
    }

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div ref={this.props.setWrapperRef} id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>
        {/*<article id="uhn" className={`${this.props.article === 'uhn' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h4 className="major">Unary Homogeneous Nucleation (UHN) of H<sub>2</sub>O</h4>
          <form onSubmit={this.handleUHNcalc}>
            <label><input style={inpStyle} type='number' step="any" name="uhntemp" value={this.state.uhntemp} min="190.0" max="300.0" onChange={this.handleUHNtemp}></input> Temperature (range 190-300  K)</label>
            <label><input style={inpStyle} type="number" step="any" name="uhnsrat" value={this.state.uhnsatratio} min="2" max="100" onChange={this.handleUHNsrat}></input> Saturation Ratio (range 2-100)</label>
            <input type="submit" value="Calculate" />
          </form>
          ----------- comment this <span className="image main"><img src={pic01} alt="" /></span>
          <label><input style={outStyle} id="uhnout1" type="number" disabled></input> UHN Nucleation Rate</label>
          <p style={inpStyle}>Reference: (1) Du, H.,A. Nadykto, and F. Yu, Quantum-mechanical solution to fundamental problems of classical theory of homogeneous water vapor nucleation, Phys. Rev. E, 79, 021604, 2009.</p>
          {close}
        </article>*/}

        <article id="bhn" className={`${this.props.article === 'bhn' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h4 className="major">Binary Homogeneous Nucleation (BHN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O</h4>
          <form onSubmit={this.handleBHNcalc}>
            <label><input style={inpStyle} type='number' step="any" name="bhnh2so4" value={this.state.bhnh2so4} min="5E5" max="5E9" onChange={this.handleBHNh2so4} required></input> H<sub>2</sub>SO<sub>4</sub> (in cm<sup>-3</sup> range 5E5 - 5E9)</label>
            <label><input style={inpStyle} type='number' step="any" name="bhntemp" value={this.state.bhntemp} min="190.0" max="304.0" onChange={this.handleBHNtemp} required></input> Temperature (range 190-304 K)</label>
            <label><input style={inpStyle} type='number' step="any" name="bhnrh" value={this.state.bhnrh} min="0.5" max="99.5" onChange={this.handleBHNrh} required></input> Relative Humidity (range 0.5-99.5 %)</label>
            <label><input style={inpStyle} type='number' step="any" name="bhnsfcarea" value={this.state.bhnsfcarea} min="1" max="1000" onChange={this.handleBHNsfcarea} required></input> Surface Area (&micro;m<sup>2</sup>cm<sup>-3</sup> range 1-1000)</label>
            <label><input type="submit" value="Calculate" /><span id="bhnstatus">&nbsp;&nbsp;Ready...</span></label>
          </form>
          {/* <span className="image main"><img src={pic02} alt="" /></span> */}
          <label><input style={outStyle} id="bhnNucRate" type="number" disabled></input> BHN Nucleation Rate (cm<sup>-3</sup>s<sup>-1</sup>)</label>
          {/*<label><input style={outStyle} id="bhnText" type="text"></input> BHN Text Box </label>*/}
          <p style={outStyle}>Reference: (1) Yu, F., Nadykto, A. B., Herb, J., Luo, G., Nazarenko, K. M., and Uvarova, L. A.: H2SO4-H2O-NH3 ternary ion-mediated nucleation (TIMN): Kinetic-based model and comparison with CLOUD measurements, Atmos. Chem. Phys.,18, 17451-17474, <a href="https://doi.org/10.5194/acp-18-17451-2018">https://doi.org/10.5194/acp-18-17451-201</a>, 2018.</p>
          {close}
        </article>

        <article id="thn" className={`${this.props.article === 'thn' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h4 className="major">Ternary Homogeneous Nucleation (THN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O-NH<sub>3</sub></h4>
          <form onSubmit={this.handleTHNcalc}>
            <label><input style={inpStyle} type='number' step="any" name="thnh2so4" value={this.state.thnh2so4} min="5E5" max="5E9" onChange={this.handleTHNh2so4} required></input> H<sub>2</sub>SO<sub>4</sub> (in cm<sup>-3</sup>) range 5E5 - 5E9)</label>
            <label><input style={inpStyle} type='number' step="any" name="thntemp" value={this.state.thntemp} min="190.0" max="304.0" onChange={this.handleTHNtemp} required></input> Temperature (range 190-304 K)</label>
            <label><input style={inpStyle} type='number' step="any" name="thnrh" value={this.state.thnrh} min="0.5" max="99.5" onChange={this.handleTHNrh} required></input> Relative Humidity (range 0.5-99.5 %)</label>
            <label><input style={inpStyle} type='number' step="any" name="thnsfcarea" value={this.state.thnsfcarea} min="1" max="1000" onChange={this.handleTHNsfcarea} required></input> Surface Area (&micro;m<sup>2</sup>cm<sup>-3</sup> range 1-1000)</label>
            <label><input style={inpStyle} type='number' step="any" name="thnnh3" value={this.state.thnnh3} min="1E5" max="1E12" onChange={this.handleTHNnh3} required></input> NH3 (cm<sup>-3</sup> range 1E5-1E12)</label>
            <label><input type="submit" value="Calculate" /><span id="thnstatus">&nbsp;&nbsp;Ready...</span></label>
          </form>
          {/* <span className="image main"><img src={pic03} alt="" /></span> */}
          <label><input style={outStyle} id="thnNucRate" type="number" disabled></input> THN Nucleation Rate (cm<sup>-3</sup>s<sup>-1</sup>)</label>
          <p style={outStyle}>Reference: (1) Yu, F., Nadykto, A. B., Herb, J., Luo, G., Nazarenko, K. M., and Uvarova, L. A.: H2SO4-H2O-NH3 ternary ion-mediated nucleation (TIMN): Kinetic-based model and comparison with CLOUD measurements, Atmos. Chem. Phys.,18, 17451-17474, <a href="https://doi.org/10.5194/acp-18-17451-2018">https://doi.org/10.5194/acp-18-17451-201</a>, 2018.</p>
          {close}
        </article>

        <article id="bimn" className={`${this.props.article === 'bimn' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h4 className="major">Binary Ion Mediated Nucleation (BIMN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O</h4>
          <form onSubmit={this.handleBIMNcalc}>
            <label><input style={inpStyle} type='number' step="any" name="bimnh2so4" value={this.state.bimnh2so4} min="5E5" max="5E9" onChange={this.handleBIMNh2so4} required></input> H<sub>2</sub>SO<sub>4</sub> (cm<sup>-3</sup> range 5E5 - 5E9)</label>
            <label><input style={inpStyle} type='number' step="any" name="bimntemp" value={this.state.bimntemp} min="190.0" max="304.0" onChange={this.handleBIMNtemp} required></input> Temperature (range 190-304 K)</label>
            <label><input style={inpStyle} type='number' step="any" name="bimnrh" value={this.state.bimnrh} min="0.5" max="99.5" onChange={this.handleBIMNrh} required></input> Relative Humidity (range 0.5-99.5 %)</label>
            <label><input style={inpStyle} type='number' step="any" name="bimnirate" value={this.state.bimnirate} min="2" max="100" onChange={this.handleBIMNirate} required></input> Ionization Rate (ion pairs cm<sup>-3</sup>s<sup>-1</sup> range 2-100)</label>
            <label><input style={inpStyle} type='number' step="any" name="bimnsfcarea" value={this.state.bimnsfcarea} min="1" max="1000" onChange={this.handleBIMNsfcarea} required></input> Surface Area (&micro;m<sup>2</sup>cm<sup>-3</sup> range 1-1000)</label>
            <label><input type="submit" value="Calculate" /><span id="bimnstatus">&nbsp;&nbsp;Ready...</span></label>
          </form>
          <label><input style={outStyle} id="bimnNucRate" type="number" disabled></input> BIMN Nucleation Rate (cm<sup>-3</sup>s<sup>-1</sup>)</label>
          {/* <span className="image main"><img src={pic03} alt="" /></span> */}
          <p style={outStyle}>Reference: (1) Yu, F., Nadykto, A. B., Herb, J., Luo, G., Nazarenko, K. M., and Uvarova, L. A.: H2SO4-H2O-NH3 ternary ion-mediated nucleation (TIMN): Kinetic-based model and comparison with CLOUD measurements, Atmos. Chem. Phys.,18, 17451-17474, <a href="https://doi.org/10.5194/acp-18-17451-2018">https://doi.org/10.5194/acp-18-17451-201</a>, 2018.</p>
           {close}
        </article>


        <article id="timn" className={`${this.props.article === 'timn' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h4 className="major">Ternary Ion Mediated Nucleation (TIMN) of H<sub>2</sub>SO<sub>4</sub>-H<sub>2</sub>O-NH<sub>3</sub></h4>
          <form onSubmit={this.handleTIMNcalc}>
            <label><input style={inpStyle} type='number' step="any" name="timnh2so4" value={this.state.timnh2so4} min="5E5" max="5E9" onChange={this.handleTIMNh2so4} required></input> H<sub>2</sub>SO<sub>4</sub> (cm<sup>-3</sup> range 5E5 - 5E9)</label>
            <label><input style={inpStyle} type='number' step="any" name="timntemp" value={this.state.timntemp} min="190.0" max="304.0" onChange={this.handleTIMNtemp} required></input> Temperature (range 190-304 K)</label>
            <label><input style={inpStyle} type='number' step="any" name="timnrh" value={this.state.timnrh} min="0.5" max="99.5" onChange={this.handleTIMNrh} required></input> Relative Humidity (range 0.5-99.5 %)</label>
            <label><input style={inpStyle} type='number' step="any" name="timnirate" value={this.state.timnirate} min="2" max="100" onChange={this.handleTIMNirate} required></input> Ionization Rate (ion pairs cm<sup>-3</sup>s<sup>-1</sup> range 2-100)</label>
            <label><input style={inpStyle} type='number' step="any" name="timnsfcarea" value={this.state.timnsfcarea} min="1" max="1000" onChange={this.handleTIMNsfcarea} required></input> Surface Area (&micro;m<sup>2</sup>cm<sup>-3</sup> range 1-1000)</label>
            <label><input style={inpStyle} type='number' step="any" name="timnnh3" value={this.state.timnnh3} min="1E5" max="1E12" onChange={this.handleTIMNnh3} required></input> NH3 (cm<sup>-3</sup> range 1E5-1E12)</label>
            <label><input type="submit" value="Calculate" /><span id="timnstatus">&nbsp;&nbsp;Ready...</span></label>
          </form>
          <label><input style={outStyle} id="timnNucRate" type="number" disabled></input> TIMN Nucleation Rate (cm<sup>-3</sup>s<sup>-1</sup>)</label>
          {/* <span className="image main"><img src={pic03} alt="" /></span> */}
          <p style={outStyle}>Reference: (1) Yu, F., Nadykto, A. B., Herb, J., Luo, G., Nazarenko, K. M., and Uvarova, L. A.: H2SO4-H2O-NH3 ternary ion-mediated nucleation (TIMN): Kinetic-based model and comparison with CLOUD measurements, Atmos. Chem. Phys.,18, 17451-17474, <a href="https://doi.org/10.5194/acp-18-17451-2018">https://doi.org/10.5194/acp-18-17451-201</a>, 2018.</p>
           {close}
        </article>


        {/* <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Contact</h2>
          <form method="post" action="#">
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" id="name" />
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input type="text" name="email" id="email" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea name="message" id="message" rows="4"></textarea>
            </div>
            <ul className="actions">
              <li><input type="submit" value="Send Message" className="special" /></li>
              <li><input type="reset" value="Reset" /></li>
            </ul>
          </form>
          <ul className="icons">
            <li><a href="#" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="#" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
            <li><a href="#" className="icon fa-instagram"><span className="label">Instagram</span></a></li>
            <li><a href="#" className="icon fa-github"><span className="label">GitHub</span></a></li>
          </ul>
          {close}
        </article> */}

      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  calc: PropTypes.string,
  calcTimeout: PropTypes.bool,
  onCloseCalc: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
